/* eslint-disable */
// prettier-ignore


export default class {

  constructor(element) {
    this.element = element
    this.places = document.querySelectorAll('[data-place]')
    this.apiKey = 'AIzaSyDq7-TztuqP25lo61tXayDOFWkY6PakqX8'

    if (window.mapsApiLoaded) {
      this.mapReady()
    }
    else {
      this.loadMapsApi()
    }
    
    this.mapConfig = [
      {
        cantons: ['be', 'ju', 'bs', 'bl', 'so'],
        opacity: 0.7
      },
      {
        cantons: ['ge', 'vd', 'ne', 'fr', 'vs'],
        opacity: 0.8
      },
      {
        cantons: ['lu', 'ow', 'nw', 'sz', 'zg', 'gl', 'ur', 'ti'],
        opacity: 0.3
      },
      {
        cantons: ['gr', 'zh', 'ag', 'tg'],
        opacity: 0.8
      },
      
    ];
  }

  mapReady() {
    this.loadInfoBox();
    window.mapsApiLoaded = true;
    this.map = this.createMap();

    for(let i = 0; i < this.places.length; i++) {
      this.createMarker(this.places[i]);
    }

    this.addOverlay();

    window.addEventListener('resize', this.resizeMap.bind(this))
  }

  addOverlay() {

    let bounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(45.8179931641, 5.955911159),
      new google.maps.LatLng(47.808380127, 10.4920501709));


    switzerlandOverlay.prototype = new google.maps.OverlayView();

    function switzerlandOverlay(bounds, svg, map) {
      this.bounds_ = bounds;
      this.svg = svg;
      this.map_ = map;
      this.div = null;

      this.setMap(map);
    }

    /**
     * onAdd is called when the map's panes are ready and the overlay has been
     * added to the map.
     */
    switzerlandOverlay.prototype.onAdd = function() {

      this.div = document.createElement('div');
      this.div.style.borderStyle = 'none';
      this.div.style.borderWidth = '0px';
      this.div.style.position = 'absolute';

      var img = document.createElement('img');
      img.src = '/themes/fenaco/src/images/switzerland.svg';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.position = 'absolute';
      //img.style.border = '1px solid blue';
      this.div.appendChild(img);

      this.div.appendChild(img);


      var panes = this.getPanes();
      panes.overlayLayer.appendChild(this.div);
    };

    switzerlandOverlay.prototype.draw = function() {

      var overlayProjection = this.getProjection();

      var sw = overlayProjection.fromLatLngToDivPixel(this.bounds_.getSouthWest());
      var ne = overlayProjection.fromLatLngToDivPixel(this.bounds_.getNorthEast());

      this.div.style.left = sw.x + 'px';
      this.div.style.top = ne.y + 'px';
      this.div.style.width = (ne.x - sw.x) + 'px';
      this.div.style.height = (sw.y - ne.y) + 'px';
    };

    this.overlay = new switzerlandOverlay(bounds, this.container, this.map);
  }




  createMarker(place) {
    let placeData = null;
    try {
       placeData = JSON.parse(place.getAttribute('data-place'));
    } catch(e) {
      console.log(e);
    }

    if (!placeData) return;

    let path = '/themes/fenaco/dist/assets'

    let markerImage = {
      url: path + '/images/marker.svg',
      size: new google.maps.Size(38, 41),
      scaledSize: new google.maps.Size(38, 41),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(38, 41)
    };


    let marker = new google.maps.Marker({
      position: {
        lat: parseFloat(placeData.coordinates[1]),
        lng: parseFloat(placeData.coordinates[0])
      },
      map: this.map,
      icon: markerImage,
      optimized: false
    });
    marker.addListener('mouseover', this.markerOver.bind(this, marker, place.getAttribute('data-title')));
    marker.addListener('mouseout', this.markerOut.bind(this, marker));
    marker.addListener('click', () => {
      place.scrollIntoView({ behavior: 'smooth' });
    });
  }

  markerOver(marker, title) {

    if (!this.infoWindow) {
      this.infoWindowNode = document.createElement("div");
      this.infoWindowNode.classList.add('map-info');
      this.infoWindowNode.innerHTML = title;

      var myOptions = {
        content: this.infoWindowNode
        ,disableAutoPan: false
        ,disableDefaultUI: true
        ,maxWidth: 0
        ,pixelOffset: new google.maps.Size(10, -35)
        ,zIndex: null
        ,closeBoxURL: ''
        ,infoBoxClearance: new google.maps.Size(1, 1)
        ,isHidden: false
        ,pane: "floatPane"
        ,enableEventPropagation: false
      };
      this.infoWindow = new InfoBox(myOptions);
    }

    this.infoWindowNode.innerHTML = title;
    this.infoWindow.open(this.map, marker);
  }

  markerOut() {
    this.infoWindow.close();
  }

  createMap() {
    return new window.google.maps.Map(this.element, {
      scrollwheel: false,
      navigationControl: false,
      mapTypeControl: false,
      scaleControl: false,
      draggable: false,
      zoom: 8,
      center: new google.maps.LatLng(46.800663464, 8.222665776),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [ { "featureType": "poi", "stylers": [ { "visibility": "off" } ] }, { "stylers": [ { "saturation": -70 }, { "lightness": 37 }, { "gamma": 1.15 } ] }, { "elementType": "labels", "stylers": [ { "gamma": 0.26 }, { "visibility": "off" } ] }, { "featureType": "road", "stylers": [ { "lightness": 0 }, { "saturation": 0 }, { "hue": "#ffffff" }, { "gamma": 0 } ] }, { "featureType": "road", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [ { "lightness": 50 }, { "saturation": 0 }, { "hue": "#ffffff" } ] }, { "featureType": "administrative.province", "stylers": [ { "visibility": "off" }, { "lightness": -50 } ] }, { "featureType": "administrative.province", "elementType": "labels.text.stroke", "stylers": [ { "visibility": "off" } ] }, { "featureType": "administrative.province", "elementType": "labels.text", "stylers": [ { "lightness": 20 } ] } ]
    });
  }

  resizeMap() {
    let zoom = 12 / 2000 * window.innerWidth;
    this.map.setZoom(
      Math.max(7, zoom)
    );
    this.map.setCenter(
      new google.maps.LatLng(
        46.800663464,
        8.222665776
      )
    );
  }


  loadMapsApi() {
    window.mapsApiLoaded = false;
    window.mapsApiCallback = this.mapReady.bind(this);

    const googleInclude = document.createElement('script');
    googleInclude.setAttribute("type", "text/javascript");
    googleInclude.setAttribute("src", `https://maps.google.com/maps/api/js?key=${this.apiKey}&callback=mapsApiCallback`);
    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(googleInclude);
  }

  loadInfoBox() {
    const infoBox = document.createElement('script');
    infoBox.setAttribute("type", "text/javascript");
    infoBox.setAttribute("src", `/libraries/infobox/1.1.9/src/infobox_packed.js`);
    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(infoBox);
  }

}
